export const normalizeFavoriteStoreId = (value: string | number | undefined): number | null => {
  const id = typeof value === 'number' ? value : Number(value)

  return Number.isSafeInteger(id) && id > 0 ? id : null
}
